import { ImagePoint } from "../../data/image-point";

/// An inventory zone is an area where inventory items are tracked.
export interface InventoryZone {
	id: string;
	name: string;
	image: InventoryZoneImage | null;
	generalAssignments: readonly InventoryAsset[];
	sections: InventorySection[];
	lastScanTime: Date | null;
}

export interface InventoryZoneImage {
	url: string;
	name: string;
}

/// A section is a sub-area of an inventory zone
/// where inventory items are tracked.
/// It is associated with a scanner to detect nearby tags,
/// and has a boundary area which is projected onto the
/// zone's layout image.
export interface InventorySection {
	id: string;
	name: string;
	assignments: readonly InventoryAsset[];
	bounds: ImagePoint[];
	scanner: InventorySectionDevice | null;
}

/// A device that can scan inventory tags in a section.
export interface InventorySectionDevice {
	id: string;
	model: string | undefined;
}

/// An asset as found in an inventory section
export interface InventoryAsset {
	id: string;
	name: string;
}

export const SAMPLE_INVENTORY_ZONE: InventoryZone = {
	id: "z1",
	name: "Sample Zone",
	image: {
		url: "https://placecats.com/300/300",
		name: "cat.png",
	},
	generalAssignments: [
		{
			id: "a1",
			name: "Sample Asset",
		},
	],
	sections: [
		{
			id: "s1",
			name: "Sample Section",
			assignments: [
				{
					id: "a1",
					name: "Sample Asset",
				},
				{
					id: "a2",
					name: "Sample Asset 2",
				},
				{
					id: "a3",
					name: "Sample Asset 3",
				},
			],
			bounds: [
				{ x: 0.2, y: 0.2 },
				{ x: 0.8, y: 0.2 },
				{ x: 0.8, y: 0.8 },
				{ x: 0.2, y: 0.8 },
			],
			scanner: {
				id: "d1",
				model: "Pavo",
			},
		},
	],
	lastScanTime: new Date(),
};
